const ACCOUNT_NAVIGATION_KEY = 'selected_account_context';

export const saveSelectedAccountContext = (context) => {
  if (!context || typeof window === 'undefined') return;

  const acType = String(context.acType || '').trim();
  const acno = String(context.acno || '').trim();
  const dashboardTab = context.dashboardTab === 'iowe' ? 'iowe' : 'iown';

  if (!acType || !acno) return;

  try {
    window.sessionStorage.setItem(
      ACCOUNT_NAVIGATION_KEY,
      JSON.stringify({
        acType,
        acno,
        dashboardTab,
      })
    );
  } catch (_error) {
    // Ignore session storage write failures.
  }
};

export const getSelectedAccountContext = () => {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.sessionStorage.getItem(ACCOUNT_NAVIGATION_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    const acType = String(parsed?.acType || '').trim();
    const acno = String(parsed?.acno || '').trim();

    if (!acType || !acno) return null;

    return {
      acType,
      acno,
      dashboardTab: parsed?.dashboardTab === 'iowe' ? 'iowe' : 'iown',
    };
  } catch (_error) {
    return null;
  }
};

export const clearSelectedAccountContext = () => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(ACCOUNT_NAVIGATION_KEY);
  } catch (_error) {
    // Ignore session storage removal failures.
  }
};

